import styled from "styled-components";
import { theme } from "../../../helpers/theme"

export const ViewBody = styled.div`
background-color: ${theme.colors.gray04_background};
display: flex;
flex-direction: row;
justify-content: space-around;
`;
export const FormWrapper = styled.div`
display: flex;
flex-direction: column;
gap: 24px;
min-width:260px;
max-width:420px;
margin: auto;
`;
export const FormHeading = styled.h4`
font-family: ${theme.fonts.interBold};
font-style: normal;
font-weight:  ${theme.fontWeight.big};
font-size: 24px;
line-height: 32px;
color: ${theme.colors.black_primaryText};
margin:0px;

@media ${theme.device.Mtablet}{
  text-align: center;
}
`;
export const Description = styled.p`
font-family: ${theme.fonts.interRegular};
font-style: normal;
font-weight: ${theme.fontWeight.small};
font-size: 14px;
line-height: 20px;
color: ${theme.colors.black_primaryText};
margin-top:0px;
`;

export const ImgSVG = styled.img`
    min-height: 3rem;
    padding-top:20%;
    padding: 10px;
    min-width:150px;
    max-width:25%;
  
@media ${theme.device.Mtablet}{
    display:none;
}`;
